import React, { useReducer } from "react";
import { useTranslation } from "react-i18next";
import { Level } from "../../../../../common/level";
import Divider from "../../../../../common/divider/Divider";
import Box from "../../../../../common/box/Box";
import TextUpload from "../upload/TextUpload";
import { reducer } from "../../previewDocuments/RequestPreviewDocumentsPageReducer";
import { back } from "../PreviewDocumentsUtils";

function AdditionalDocs({ pageState, setIsBlocking, disabled, setSelected }) {
  const { t } = useTranslation();
  const [state, dispatch] = useReducer(reducer, pageState);

  return (
    <>
      <div className="block">
        <Divider label={t("requests.reviewDocuments.additionalDocs.divider")} />
        {/*      {state.additionalDocs.map((additionalDoc, index) => (
              <Box
                key={"detail" + index}
                statusIndicatorPosition="left"
                statusIndicatorColor={additionalDoc.color}
                className="is-size-5"
              >
                <Level>
                  <Level.Side align="left">
                    {index + 1}. {additionalDoc.label}
                  </Level.Side>
                </Level>
              </Box>
            ))} */}
        <TextUpload
          isAdditional={true}
          disabled={disabled}
          documents={state.additionalDocs}
          dispatchUpdateAction={() => {
            setIsBlocking(true);
            back(setSelected, setIsBlocking, disabled);
            dispatch({
              type: "update-documents",
            });
          }}
        >
          {/* {state.additionalDocs.length > 0 && ( */}
          <>
            {state.additionalDocs.map((additionalDoc, index) => (
              <Box
                key={"detail" + index}
                statusIndicatorPosition="left"
                statusIndicatorColor={additionalDoc.color}
                className="box is-size-5 py-5"
              >
                <Level>
                  <Level.Side align="left">
                    {index + 1}. {additionalDoc.label}
                  </Level.Side>
                </Level>
              </Box>
            ))}
          </>
        </TextUpload>
      </div>
    </>
  );
}

export default AdditionalDocs;
